import React from 'react';
import { testId } from '@lojinha/helpers/src/test-id';
import { theme } from '../../../theme';
export const Check = ({ color, size }) => {
    return (React.createElement("svg", { width: theme.fontSizes[size], height: "auto", viewBox: "0 0 11 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...testId('check-icon') },
        React.createElement("path", { d: "M10 1L4 7L1 4", stroke: theme.colors[color], strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
Check.defaultProps = {
    color: 'success',
    size: 'x0',
};
//# sourceMappingURL=index.js.map